


























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import { Facility } from './../../models/jobs/facility';
import { getJobPayUnit } from './../MyJobs/MyJobsUtils';

@Component
export default class SimilarJobs extends Vue {
  @Prop() jobDetail
  $moment: any;
  public isHover : boolean = false;
  public hoveredJobId: string | null = null;


  get similarJobs(): Job[] {
    /*let jobs = vxm.jobs.Jobs;
    let currentJobDetails = vxm.jobs.AnonymousJobByID;
    if (jobs && currentJobDetails) {
      jobs = jobs.filter(
        (job) => job.jobPostingId !== currentJobDetails.jobPostingId,
      );
    }*/
    let jobs = vxm.jobs.SimilarJobs;
    vxm.jobs.setSimilarJobs([]);
    return jobs;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get referaFriendTitle() {
    return vxm.configs.getGlobalConfigValue('REFER_A_FRIEND_TITLE');
  }

  get referralBannerURL() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/CANDIDATEPORTAL/ic_referbanner.png`;
  }
  get jobHiddenFields() {
    return vxm.configs.getGlobalConfigValue('JOB_HIDDEN_FIELDS') 
  }

  canShowField(fieldName) {
    if(this.jobHiddenFields){
      const hiddenFields = this.jobHiddenFields.split(',').map((field) =>
        field
          .trim()
          .toLowerCase()
          .replace(/\s/g, ''),
      );
       return !hiddenFields.includes(fieldName);
    }
    return true;
  }
  goTodetailWithTitle(jid: string, jTitle: string, facility: Facility) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    let city = facility.city ? facility.city.trim() : facility.city;
    localStorage.jobviewpage = true;
    let jobTitleSlug = this.jobTitleCitySlug(jTitle, city);
    this.$router.push({
      name: 'findjobs',
    });
    setTimeout(() => {
      this.$router.push({
        name: 'JobdetailsSlug',
        params: { JobID: jid, JobSlug: jobTitleSlug },
      });
    }, 1);
  }

  jobTitleCitySlug(jTitle: string, city: string): string {
    let slug = '';
    slug = jTitle
      .split(' ')
      .join('-')
      .toLowerCase();
    if (city !== null && city.length > 0) {
      slug = slug.concat('-in-').concat(city.toLowerCase());
    }
    return slug;
  }

  get referFriendLink() {
    if (vxm.users.isLoggedIn) {
      return '/referafriend';
    } else if (vxm.configs.getGlobalConfigBooelanValue('REFERFRIEND_AFTER_LOGIN_ONLY')) {
      return '/login';
    } else {
      return '/anonreferafriend';
    }
  }

  jobStartTime(job: Job): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return job.startImmediately
        ? 'Immediately'
        : this.$moment(job.startDTTM).format(
            vxm.jobs.getCompanyDateFormat.toUpperCase(),
          );
    }
    return job.startImmediately
      ? 'Immediately'
      : this.$moment(job.startDTTM).format('DD-MMM-YYYY');
  }

  get payRateNegotiableText() {
    return vxm.configs.getGlobalConfigValue('NEGOTIABLE_JOB_TEXT');
  }

  getFormattedLocationName(facility: any, jobPostingMetaData: any) {
    if (jobPostingMetaData) {
      let facilityMetaData = jobPostingMetaData.filter(
        (meta: any) => meta.name === 'facilityName',
      );
      if (facilityMetaData && facilityMetaData[0].displayFormat) {
        const city = facility.city ? facility.city.trim() : facility.city;
        const state = facility.state ? facility.state.trim() : facility.state;
        const country = facility.country
          ? facility.country.trim()
          : facility.country;
        const name = facility.name ? facility.name.trim() : facility.name;
        if(city!=null && state!=null){
        return facilityMetaData[0].displayFormat
          .replace('{$.Facility.City}', city)
          .replace('{$.Facility.State}', state)
          .replace('{$.Facility.Country}', country)
          .replace('{$.Facility.Name}', name);
      }
      else if(country!=null && state!=null){
        return state+','+country
      }
      else if(country!=null){
        return country
      }
      return null
    }
    }
    return facility.name;
  }

  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  otherLocales(job) {
    const additionalFacilities = JSON.parse(job.additional_facility);
    const facilityNames = additionalFacilities.map( facility => {
      return facility.name.trim();
    }).filter(name => name);
    console.log("facilityNames",facilityNames);
    return facilityNames;
  }

  jobTypeText(job: Job): string {
    if (job.candidatePlacementTypeText) {
      return job.candidatePlacementTypeText;
    }
    if (job.jobPostingType === '01') {
      return this.$t('Full time').toString();
    }
    if (job.jobPostingType === '02' || job.jobPostingType === '03') {
      if (job.candidatePlacementTypeValue === '00') {
        return this.$t('Full Time Contract Job').toString();
      } else {
        return this.$t('Part Time Contract Job').toString();
      }
    }
    return '';
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  getPayUnit(job) {
    return getJobPayUnit(job);
  }

  mounted() {

  }
}
